var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 3.4C5.45959 3.4 3.4001 5.45949 3.4001 8C3.4001 10.5405 5.45959 12.6 8.0001 12.6C10.5406 12.6 12.6001 10.5405 12.6001 8C12.6001 5.45949 10.5406 3.4 8.0001 3.4ZM2.6001 8C2.6001 5.01766 5.01776 2.6 8.0001 2.6C10.9825 2.6 13.4001 5.01766 13.4001 8C13.4001 10.9824 10.9825 13.4 8.0001 13.4C5.01776 13.4 2.6001 10.9824 2.6001 8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53345 6.88889C5.53345 6.44706 5.89162 6.08889 6.33345 6.08889H6.339C6.78083 6.08889 7.139 6.44706 7.139 6.88889C7.139 7.33072 6.78083 7.68889 6.339 7.68889H6.33345C5.89162 7.68889 5.53345 7.33072 5.53345 6.88889ZM8.86678 6.88889C8.86678 6.44706 9.22495 6.08889 9.66678 6.08889H9.67234C10.1142 6.08889 10.4723 6.44706 10.4723 6.88889C10.4723 7.33072 10.1142 7.68889 9.67234 7.68889H9.66678C9.22495 7.68889 8.86678 7.33072 8.86678 6.88889Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14596 9.28849C6.30217 9.13228 6.55544 9.13228 6.71165 9.28849C7.42329 10.0001 8.57703 10.0001 9.28865 9.28849C9.44486 9.13228 9.69812 9.13228 9.85433 9.28849C10.0105 9.4447 10.0105 9.69797 9.85433 9.85418C8.83029 10.8782 7.17003 10.8782 6.14597 9.85418C5.98976 9.69797 5.98975 9.4447 6.14596 9.28849Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.c624ebccfc11c123562aed5ce4e69ac0.svg";
export { ForwardRef as ReactComponent };